/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-04-28",
    versionChannel: "nightly",
    buildDate: "2023-04-28T00:25:57.750Z",
    commitHash: "60ffe07ae7d810777c46b16df77ead92f1ce93d6",
};
